export const internal = Symbol.for('sxs.internal');
